module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.documents), function(documentNames, clientId) {
    return _c('ul', {
      key: clientId
    }, [_c('li', {
      staticClass: "client"
    }, [_c('p', [_vm._v("\n        Идентификатор клиента: "), _c('span', [_vm._v(_vm._s(clientId))])]), _vm._v(" "), _c('p', [_vm._v("Документы:")]), _vm._v(" "), _vm._l((documentNames), function(documentPath, i) {
      return _c('ul', {
        key: i
      }, [_c('li', {
        staticClass: "document"
      }, [_c('a', {
        attrs: {
          "href": _vm.fileUri + '/' + documentPath,
          "target": "_blank",
          "rel": "noopener noreferrer"
        }
      }, [_vm._v(_vm._s(documentPath
        .replace('upload/files/uprid/documents/', '')
        .replace(clientId + '/', '')))])])])
    })], 2), _vm._v(" "), _c('hr')])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63754189"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uprid/Documents.vue
// module id = 957
// module chunks = 0